import { startEditor } from "../editor/ui/app";

// モジュールの評価が DOMContentLoaded 後になる場合があるため、状態を見て起動する
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => startEditor());
} else {
  startEditor();
}
